module.exports = __webpack_public_path__ + "static/media/MaduruOya.63bec038.png";